import React from 'react'
import useMediaQuery from '../../../shared/utils/useMediaQuery'

import './card-diamond-info-product.scss'

const CardDiamondInfoProduct = ({
  image,
  title,
  className = '',
  description = '',
  footer,
  open = false,
  num,
  onClick,
}) => {
  const isMobile = useMediaQuery()
  const clickHandler = () => {
    if (onClick) {
      onClick(num)
    }
  }
  return (
    <div
      className={'f-card-diamond-info-product ' + className}
      onClick={clickHandler}
    >
      <div className="f-card-diamond-info-product__wrapper-top">
        <div className="f-card-diamond-info-product__numbertag">
          <span>{num}</span>
        </div>
      </div>
      <div className="f-card-diamond-info-product__wrapper-middle">
        <div>
          <figure className="f-card-diamond-info-product__figure">
            <img
              className="f-card-diamond-info-product__image"
              src={image}
              alt={'producto ' + title}
            />
          </figure>
        </div>
        <div style={{ width: '100%' }}>
          <p className="f-card-diamond-info-product__title">{title}</p>
          {!isMobile && <br />}
          <p className="f-card-diamond-info-product__text">{description}</p>
        </div>
      </div>
      <div className="f-card-diamond-info-product__wrapper-bottom">
        {footer}
      </div>
      <a
        className="f-card-diamond-info-product__buttonplus"
        onClick={clickHandler}
      >
        {!open ? '+' : '-'}
      </a>
    </div>
  )
}
export default CardDiamondInfoProduct
